<template>
    <div>
        <ul v-if="tempAttachments.length > 0">
            <li v-for="tempAttachment in tempAttachments" :key="tempAttachment._id">
                <img class="icon" :src="tempAttachment.iconURL">
                <div class="file-details">
                    <div class="file-name display-flex align-center">
                        <p class ref="attachmentTitle">{{ tempAttachment.title }}</p>
                    </div>
                    <div class="file-info">
                        <span v-if="tempAttachment.size > 0" class="uploaded-date">File Size : {{ tempAttachment.size }} bytes</span>
                        <span v-if="checkProgress(tempAttachment)" class="upload-prgress"></span>
                    </div>
                </div>
                <v-btn depressed flat @click="deleted(tempAttachment)">
                    <font-awesome-icon icon="trash" class="trash-icon" />
                </v-btn>
            </li>
        </ul>
    </div>
</template>

<script>
    import {VBtn} from 'vuetify/lib'

    export default {
        components: {VBtn},
        name: "AttachmentList",
        methods: {
            checkProgress(attachment) {
                return attachment.progress === null ? false : true;
            },
            deleted(attachment) {
                var index = this.tempAttachments.indexOf(attachment);
                if (index > -1) {
                    this.tempAttachments.splice(index, 1);
                }
            }
        },
        props: {
            tempAttachments: {
                type: Array
            }
        }
    };
</script>
<style scoped>
    ul {
        display: flex;
        flex-wrap: wrap;
        list-style: none;
        padding: 0px;
    }
    li {
        position: relative;
        display: flex;
        align-items: center;
        margin-bottom: 8px;
        padding: 16px;
        width: 100%;
        text-align: left;
        background: #ffffff;
        box-shadow: 0 1px 2px 0 rgba(3, 22, 41, 0.11),
        0 6px 16px 0 rgba(3, 22, 41, 0.08);
        border-radius: 6px;
    }
    .file-name {
        min-width: 150px;
        font-size: 16px;
    }
    .file-name p {
        margin: 0;
    }
    .uploaded-date {
        font-size: 12px;
        font-weight: 300;
    }
    .upload-progress {
        font-size: 12px;
        font-weight: 300;
    }
    .file-details {
        flex: 1;
    }
    .file-info {
        display: flex;
        justify-content: space-between;
        margin: 0px;
    }
    .close {
        position: absolute;
        margin: 0px;
        top: 50%;
        transform: translateY(-50%);
        right: 16px;
        cursor: pointer;
    }
    .close:hover g {
        stroke: #41b883;
    }
    .icon {
        width: 32px;
        height: 32px;
        margin-right: 16px;
    }
</style>